import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'device_spec',
    initialState: { spec: {}, builtin_spec: {}, extension_spec: {} },
    reducers: {
        // @ts-ignore
        receivedOk: (state, action) => {
            state.spec = action.payload.device_spec;
            state.builtin_spec = action.payload.builtin_spec;
            state.extension_spec = action.payload.extensions_spec;
        },
    },
});
export const requestDeviceSpec = () => async (dispatch, getState, { api }) => {
    try {
        const response = await api.get_device_spec();
        dispatch(receivedOk(response));
    }
    catch (error) { }
};
export const { receivedOk } = slice.actions;
export const deviceSpecReducer = slice.reducer;
